import { useEffect, useState } from 'react';
import { teamLogoUrl } from '../api';
import { classNames } from '../classNames';

const SIZES = {
  xs: 'h-6 w-6 text-xs',
  sm: 'h-9 w-9 text-base',
  md: 'h-14 w-14 text-xl',
};

export function TeamLogo({
  teamId,
  teamName,
  version,
  src,
  size = 'md',
  fallback = 'letter',
}: {
  teamId: string;
  teamName: string;
  version?: string;
  /** Shows this image instead of the stored logo. */
  src?: string;
  size?: keyof typeof SIZES;
  fallback?: 'letter' | 'none';
}) {
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    setMissing(false);
  }, [teamId, version]);

  const blank = !src && (missing || !teamId);
  if (blank && fallback === 'none') return null;

  const className = classNames(
    'shrink-0 rounded-md border border-hairline bg-surface',
    SIZES[size],
  );

  if (blank) {
    return (
      <span
        aria-hidden
        className={classNames(
          className,
          'flex items-center justify-center font-medium text-muted',
        )}
      >
        {teamName.trim().charAt(0).toUpperCase()}
      </span>
    );
  }
  return (
    <img
      src={src ?? teamLogoUrl(teamId, version)}
      alt={`${teamName} logo`}
      className={classNames(className, 'object-cover')}
      onError={() => setMissing(true)}
    />
  );
}
